<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="商标名称" name="brandName">
                <a-input v-model:value="searchForm.brandName" placeholder="请输入商标名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #brandIndustryType="{text}">
                <dict-render :dict-obj="dictObjs['projectType']" :text="text"></dict-render>
            </template>

            <template #auditStatus="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['aduit_status']" :text="text"
                                 :style="dictObjs['aduit_status']?.cssClass"></dict-render>
                </a-tag>
            </template>

            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->

                    <a-dropdown>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item key="1">
                                    <a @click="onEdit(record)">编辑</a>
                                </a-menu-item>
                                <!-- <a-menu-item key="2">
                                    <a @click="onSellerCancel(record)">取消交易</a>
                                </a-menu-item> -->
                                <a-menu-item key="3">
                                    <a @click="onJoint(record)">发布交易</a>
                                </a-menu-item>
                                <a-menu-item key="4">
                                    <a @click="onDetail(record)">详情</a>
                                </a-menu-item>
                            </a-menu>
                        </template>
                        <a class="ant-dropdown-link" @click.prevent>更多
                            <DownOutlined/>
                        </a>
                    </a-dropdown>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <PublishTransactionsModal ref="publishModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>

</template>

<script>
    import AddOrEditModal from "./components/AddOrEditModal";
    import PublishTransactionsModal from "./components/PublishTransactionsModal"
    import {dictMixin, tableListMixin} from "@/mixins";
    import {brandApi} from "@/api/knowledge";
    import DictRender from "@/components/other/DictRender";
    import Detail from "./components/DetailModal"

    const columns = [
        // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        {title: "商标名称", dataIndex: "brandName", key: "brandName"},
        {title: "行业类型", dataIndex: "brandIndustryType", key: "brandIndustryType", slots: {customRender: "brandIndustryType"}},
        {title: "注册公告期号", dataIndex: "brandNumber", key: "brandNumber"},
        {title: "审核状态", dataIndex: "auditStatus", key: "auditStatus",slots: {customRender: "auditStatus"}},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];
    export default {
        name: "index",
        mixins: [tableListMixin, dictMixin],
        components: {
            DictRender, AddOrEditModal, Detail,PublishTransactionsModal
        },
        data() {
            return {
                dictNames: 'projectType,aduit_status',
                columns,
                queryParamFixed: {},
                listUrl: brandApi.pageList,
                listKeyField: "id",
                deleteUrl: brandApi.remove,
                jointId: null,
            }
        },
        methods: {
            onAdd() {
                this.onShowModal('modal');
            },
            onEdit(record) {
                this.getAction({
                    url: brandApi.detail,
                    params: {id: record.id}
                }).then(res => {
                    this.onShowModal('modal', res);
                })
            },
            onSellerCancel(record) {
                this.postAction({
                    url: brandApi.sellerCancel,
                    params: {id: record.id}
                }).then(res => {
                    console.log("res", res)
                })
            },
            onDetail(record) {
                this.getAction({
                    url: brandApi.detail,
                    params: {
                        id: record.id,
                    }
                }).then(res => {
                    console.log(res, 'res')
                    this.onShowModal("detailmodal", res)
                })
            },
            onJoint(record) {
                this.onShowModal('publishModal',{propertyId:record.id,propertyType:"2"});
            },

        }
    }
</script>

<style scoped>

</style>
